export default __webpack_public_path__ + "static/media/blue_avatar.da58355a.svg";